import { IPosition, IPositionWithDrawing } from 'src/generated-types'
import { PositionConfig, SelectedPositionLabel } from 'src/generated-types/configure-positions'
import { getPositionName } from 'src/utils/function'

export const positionLabel = (position: IPosition) => {
  return getPositionName(position) || position.name || String(position.id)
}

export const comparePositions = (a: IPosition, b: IPosition) => {
  return positionLabel(a).localeCompare(positionLabel(b), undefined, { numeric: true, sensitivity: 'base' })
}

export const buildSelectedPositionLabels = (
  selectedIds: Set<number>,
  positionById: Map<number, IPositionWithDrawing>,
  configById: Map<number, PositionConfig>,
): SelectedPositionLabel[] => {
  return [...selectedIds]
    .map(id => positionById.get(id))
    .filter((position): position is IPositionWithDrawing => !!position)
    .sort(comparePositions)
    .map(position => ({
      id: position.id,
      label: positionLabel(position),
      color: configById.get(position.id)?.color,
    }))
}
